import { BadgeCssClassStatusEnum } from 'app/back-office/shared/enum/badge-css-class-status.enum.model';
import { OrderItemsColumnsEnum } from 'app/back-office/shared/enum/order-columns.enum.model';
import { OrderItemFulfillmentStatusEnum } from 'app/back-office/shared/enum/order-item-fulfillment-status.enum';
import { GridColumn, GridColumnTypeEnum } from 'app/back-office/shared/models/common/grid-settings.model';

export class ColumnsListGroup {
  id: ColumnsListGroupEnum;
  title: string;
  items: ColumnsListItem[];
  hideInExportXlsx?: boolean;

  constructor(init?: ColumnsListGroup) {
    Object.assign(this, init);
    if (!this.items) this.items = [];
  }
}

export class ColumnsListItem {
  checked: boolean;
  id: OrderItemsColumnsEnum;
  gridColumn: GridColumn;
  groupId: ColumnsListGroupEnum;
  hideToAgentAndCustomer?: boolean;
  hideToSupportsStockLimits?: boolean;
  hideToNotSupportsManualDiscounts?: boolean;
  hideToNotSupportsChannelDiscounts?: boolean;
  hideToNotSupportsAutomaticDiscounts?: boolean;
}

export enum ColumnsListGroupEnum {
  GENERAL = 1,
  UNITARY = 2,
  TOTALS = 3,
  PERCENT = 4,
  FULFILLMENT = 5
}


export const ColumnsList: ColumnsListItem[] = [
  {
    checked: true,
    id: OrderItemsColumnsEnum.variantImg,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.variantImg,
      type: GridColumnTypeEnum.img,
      name: 'ORDER_DETAIL.COLUMNS.IMAGE',
      prop: 'imgPath',
      disableShowColumnName: true,
      width: 55,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.productCode,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.productCode,
      name: 'ORDER_DETAIL.COLUMNS.PRODUCT_CODE',
      prop: 'productCode',
      otherProp: 'extCode',
      minWidth: 100,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: true,
    id: OrderItemsColumnsEnum.productTitle,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.productTitle,
      name: 'ORDER_DETAIL.COLUMNS.PRODUCT_TITLE',
      prop: 'productTitle',
      minWidth: 100,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.gender,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.gender,
      name: 'ORDER_DETAIL.COLUMNS.GENDER',
      prop: 'gender',
      width: 120,
      type: GridColumnTypeEnum.string,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: true,
    id: OrderItemsColumnsEnum.colorCode,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.colorCode,
      name: 'ORDER_DETAIL.COLUMNS.COLOR_CODE',
      prop: 'colorCode',
      otherProp: 'extPaletteId',
      minWidth: 100,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.colorName,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.colorName,
      name: 'ORDER_DETAIL.COLUMNS.COLOR_NAME',
      prop: 'colorName',
      width: 100,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.sizeGroup,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.sizeGroup,
      name: 'ORDER_DETAIL.COLUMNS.SIZE_GROUP',
      prop: 'sizeGroup',
      width: 100,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.styleGroup,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.styleGroup,
      name: 'ORDER_DETAIL.COLUMNS.STYLE_GROUP',
      prop: 'productStyleGroup',
      childProp: 'name',
      width: 100,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: true,
    id: OrderItemsColumnsEnum.sizeName,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.sizeName,
      name: 'ORDER_DETAIL.COLUMNS.SIZE',
      prop: 'size',
      minWidth: 80,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.ean,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.ean,
      name: 'ORDER_DETAIL.COLUMNS.EAN',
      prop: 'ean',
      minWidth: 140,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.sku,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.sku,
      name: 'ORDER_DETAIL.COLUMNS.SKU',
      prop: 'sku',
      minWidth: 180,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.date,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.date,
      name: 'ORDER_DETAIL.COLUMNS.DATE',
      prop: 'orderItemDeliveryDate',
      width: 120,
      type: GridColumnTypeEnum.date,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: true,
    id: OrderItemsColumnsEnum.qty,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.qty,
      name: 'ORDER_DETAIL.COLUMNS.QTY',
      prop: 'realQuantity',
      otherProp: 'alreadyFulfilledQuantity',
      width: 70,
      type: GridColumnTypeEnum.custom,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: true,
    id: OrderItemsColumnsEnum.note,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.note,
      name: 'ORDER_DETAIL.COLUMNS.NOTE',
      prop: 'note',
      width: 180,
      type: GridColumnTypeEnum.stringEdit,
    }),
    groupId: ColumnsListGroupEnum.GENERAL
  },
  {
    checked: true,
    id: OrderItemsColumnsEnum.unitRetail,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.unitRetail,
      name: 'ORDER_DETAIL.COLUMNS.UNIT_RETAIL',
      prop: 'unitPriceRetail',
      type: GridColumnTypeEnum.price,
      width: 120,
    }),
    groupId: ColumnsListGroupEnum.UNITARY
  },
  {
    checked: true,
    id: OrderItemsColumnsEnum.unitWholesale,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.unitWholesale,
      name: 'ORDER_DETAIL.COLUMNS.UNIT_WHOLESALE',
      prop: 'wholeSalePrice',
      type: GridColumnTypeEnum.price,
      width: 120,
    }),
    groupId: ColumnsListGroupEnum.UNITARY,
    hideToSupportsStockLimits: true
  },
  {
    checked: true,
    id: OrderItemsColumnsEnum.discountedUnitPrice,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.discountedUnitPrice,
      name: 'ORDER_DETAIL.COLUMNS.UNIT_NET',
      prop: 'discountedUnitPrice',
      type: GridColumnTypeEnum.price,
      width: 130,
    }),
    groupId: ColumnsListGroupEnum.UNITARY,
    hideToSupportsStockLimits: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.unitCost,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.unitCost,
      name: 'ORDER_DETAIL.COLUMNS.UNIT_COST',
      prop: 'itemCost',
      width: 100,
      type: GridColumnTypeEnum.price,
    }),
    groupId: ColumnsListGroupEnum.UNITARY,
    hideToAgentAndCustomer: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.unitMargin,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.unitMargin,
      name: 'ORDER_DETAIL.COLUMNS.UNIT_MARGIN',
      prop: 'marginValue',
      width: 110,
      type: GridColumnTypeEnum.price,
    }),
    groupId: ColumnsListGroupEnum.UNITARY,
    hideToAgentAndCustomer: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.totalRetail,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.totalRetail,
      name: 'ORDER_DETAIL.COLUMNS.TOTAL_RETAIL',
      prop: 'totalRetail',
      type: GridColumnTypeEnum.price,
      width: 140,
    }),
    groupId: ColumnsListGroupEnum.TOTALS
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.totalWholesale,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.totalWholesale,
      name: 'ORDER_DETAIL.COLUMNS.TOTAL_WHOLESALE',
      prop: 'totalWholesale',
      type: GridColumnTypeEnum.price,
      width: 140,
    }),
    groupId: ColumnsListGroupEnum.TOTALS,
    hideToSupportsStockLimits: true
  },
  {
    checked: true,
    id: OrderItemsColumnsEnum.discountedTotalPrice,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.discountedTotalPrice,
      name: 'ORDER_DETAIL.COLUMNS.TOTAL_NET',
      prop: 'discountedTotalPrice',
      width: 140,
      type: GridColumnTypeEnum.price,
    }),
    groupId: ColumnsListGroupEnum.TOTALS,
    hideToSupportsStockLimits: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.totalCost,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.totalCost,
      name: 'ORDER_DETAIL.COLUMNS.TOTAL_COST',
      prop: 'costTotValue',
      width: 110,
      type: GridColumnTypeEnum.price,
    }),
    groupId: ColumnsListGroupEnum.TOTALS,
    hideToAgentAndCustomer: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.totalMargin,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.totalMargin,
      name: 'ORDER_DETAIL.COLUMNS.TOTAL_MARGIN',
      prop: 'marginTotValue',
      width: 110,
      type: GridColumnTypeEnum.price,
    }),
    groupId: ColumnsListGroupEnum.TOTALS,
    hideToAgentAndCustomer: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.discountFromRetail,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.discountFromRetail,
      name: 'ORDER_DETAIL.COLUMNS.TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL',
      prop: 'totalDiscountPercentageFromRetail',
      width: 160,
      type: GridColumnTypeEnum.percentage,
    }),
    groupId: ColumnsListGroupEnum.PERCENT
  },
  {
    checked: true,
    id: OrderItemsColumnsEnum.discountFromWholesale,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.discountFromWholesale,
      name: 'ORDER_DETAIL.COLUMNS.TOTAL_DISCOUNT_PERCENTAGE',
      prop: 'totalDiscountPercentage',
      width: 140,
      type: GridColumnTypeEnum.percentage,
    }),
    groupId: ColumnsListGroupEnum.PERCENT,
    hideToSupportsStockLimits: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.customerDiscountPerc,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.customerDiscountPerc,
      name: 'ORDER_DETAIL.COLUMNS.CUSTOMER_DISCOUNT',
      prop: 'customerDiscountPercentage',
      type: GridColumnTypeEnum.percentage,
      width: 150,
    }),
    groupId: ColumnsListGroupEnum.PERCENT
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.agreementDiscountPerc,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.agreementDiscountPerc,
      name: 'ORDER_DETAIL.COLUMNS.AGREEMENT_DISCOUNT',
      prop: 'agreementDiscountPercentage',
      type: GridColumnTypeEnum.percentage,
      width: 150,
    }),
    groupId: ColumnsListGroupEnum.PERCENT
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.financialDiscountPerc,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.financialDiscountPerc,
      name: 'ORDER_DETAIL.COLUMNS.FINANCIAL_DISCOUNT',
      prop: 'financialDiscountPerc',
      type: GridColumnTypeEnum.percentage,
      width: 150,
    }),
    groupId: ColumnsListGroupEnum.PERCENT,
    hideToNotSupportsManualDiscounts: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.storeChannelDiscountPerc,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.storeChannelDiscountPerc,
      name: 'ORDER_DETAIL.COLUMNS.STORECHANNEL_DISCOUNT',
      prop: 'channelDiscountPerc',
      type: GridColumnTypeEnum.percentage,
      width: 150,
    }),
    groupId: ColumnsListGroupEnum.PERCENT,
    hideToNotSupportsChannelDiscounts: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.discountByQty,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.discountByQty,
      name: 'ORDER_DETAIL.COLUMNS.DISCOUNT_BY_QTY',
      prop: 'automaticDiscountByQTY',
      width: 160,
      type: GridColumnTypeEnum.percentage,
    }),
    groupId: ColumnsListGroupEnum.PERCENT,
    hideToNotSupportsAutomaticDiscounts: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.discountByValue,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.discountByValue,
      name: 'ORDER_DETAIL.COLUMNS.DISCOUNT_BY_VALUE',
      prop: 'automaticDiscountByValue',
      width: 160,
      type: GridColumnTypeEnum.percentage,
    }),
    groupId: ColumnsListGroupEnum.PERCENT,
    hideToNotSupportsAutomaticDiscounts: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.commercialDiscountPerc,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.commercialDiscountPerc,
      name: 'ORDER_DETAIL.COLUMNS.COMMERCIAL_DISCOUNT',
      prop: 'commercialDiscountPerc',
      type: GridColumnTypeEnum.percentage,
      width: 150,
    }),
    groupId: ColumnsListGroupEnum.PERCENT,
    hideToNotSupportsManualDiscounts: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.marginPercent,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.marginPercent,
      name: 'ORDER_DETAIL.COLUMNS.MARGIN_PERCENTAGE',
      prop: 'marginPercentage',
      width: 110,
      type: GridColumnTypeEnum.percentage,
    }),
    groupId: ColumnsListGroupEnum.PERCENT,
    hideToAgentAndCustomer: true
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.orderedQty,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.orderedQty,
      name: 'ORDER_DETAIL.COLUMNS.ORDERED_QTY',
      prop: 'erpQuantity',
      type: GridColumnTypeEnum.number,
      width: 140,
    }),
    groupId: ColumnsListGroupEnum.FULFILLMENT
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.canceledQty,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.canceledQty,
      name: 'ORDER_DETAIL.COLUMNS.CANCELED_QTY',
      prop: 'erpCancelledQuantity',
      type: GridColumnTypeEnum.number,
      width: 140,
    }),
    groupId: ColumnsListGroupEnum.FULFILLMENT
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.notFulfilledQty,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.notFulfilledQty,
      name: 'ORDER_DETAIL.COLUMNS.NOT_FULFILLED_QTY',
      prop: 'erpQuantityPendingFulfillment',
      type: GridColumnTypeEnum.number,
      width: 140,
    }),
    groupId: ColumnsListGroupEnum.FULFILLMENT
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.deliveredQty,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.deliveredQty,
      name: 'ORDER_DETAIL.COLUMNS.FULFILLED_QTY',
      prop: 'erpFulfilledQuantity',
      type: GridColumnTypeEnum.number,
      width: 140,
    }),
    groupId: ColumnsListGroupEnum.FULFILLMENT
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.fulfillmentStatus,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.fulfillmentStatus,
      name: 'ORDER_DETAIL.COLUMNS.FULFILLMENT_STATUS',
      prop: 'fulfillmentStatus',
      type: GridColumnTypeEnum.status,
      width: 140,
      statusLabelsWithCssClass: [
        { label: 'STATUS.CONCLUDED', cssClass: BadgeCssClassStatusEnum.success, enumValue: OrderItemFulfillmentStatusEnum.Concluded },
        { label: 'STATUS.PARTIAL', cssClass: BadgeCssClassStatusEnum.warning, enumValue: OrderItemFulfillmentStatusEnum.Partial },
        { label: 'STATUS.PENDING', cssClass: BadgeCssClassStatusEnum.info, enumValue: OrderItemFulfillmentStatusEnum.Pending },
        { label: 'STATUS.CANCELLED', cssClass: BadgeCssClassStatusEnum.danger, enumValue: OrderItemFulfillmentStatusEnum.Cancelled },
      ]
    }),
    groupId: ColumnsListGroupEnum.FULFILLMENT
  },
  {
    checked: false,
    id: OrderItemsColumnsEnum.CancellationReason,
    gridColumn: new GridColumn({
      order: OrderItemsColumnsEnum.CancellationReason,
      name: 'ORDER_DETAIL.STATS.COLUMNS.CANCELLATION_REASON',
      prop: 'cancellationReason',
      childProp: 'code',
      type: GridColumnTypeEnum.string,
      width: 140,
    }),
    groupId: ColumnsListGroupEnum.FULFILLMENT
  },
];
